
      const home = {
  "isolationStart": "Начало изоляции",
  "isolationEnd": "Конец изоляции",
  "segregationTime": "Время изоляции",
  "noSegregationTime": "Не указано",
  "fingerNum": "Номер домашней зоны",
  "totalNumber": "Всего",
  "searchTip": "Пожалуйста введите поисковые реквезиты",
  "online": "Oнлайн",
  "offline": "Oффлайн",
  "all": "Все",
  "alarm": "Тревога",
  "allPerson": "Все",
  "bindWatch": "Устройство связывается",
  "unbindWatch": "Разорвать связь",
  "tree": "Иерархия",
  "list": "Список",
  "loadMore": "Загрузить еще",
  "statu": "Статус",
  "command": "Команда",
  "sendUnlockCommand": "Открыть замок",
  "sendCommandToUseWearCheck": "Проверка состояния замка",
  "sendCommandToNonuseseWearCheck": "Остановить проверку состояния замка",
  "useWearCheck": "Мониторинг включен",
  "nonuseWearCheck": "Мониторинг выключен",
  "location": "Место",
  "locationTime": "Обновить время",
  "sendLocationCommand": "Обновить местоположение",
  "time": "Время",
  "noData": "Нет информации",
  "step": "Шагов",
  "sendCommandToInstantHeartRate": "Проверка пульса",
  "beatPerMin": "уд./мин.",
  "info": "Информация",
  "track": "Трек",
  "health": "здоровье",
  "alarms": "Тревоги",
  "hook": "Журнал",
  "noLocationTip": "Нет информации о местоположении",
  "noLocationDescription": "Попробуйте еще раз позже.",
  "requestTimeOut": "Большая задержка в сети",
  "sendCommandSuccess": "Команда успешно отправлена",
  "heartRataSuccess": "Пульс успешно измерен",
  "locationSuccess": "Местоположение определено",
  "sendUnlockSuccess": "Устройство открыто",
  "heartRateFailed": "Не удалось измерить пульс",
  "commandFailed": "Команда не введена",
  "personInfo": "Носитель",
  "deviceInfo": "Устройство",
  "heartRate": "Пульс",
  "noPosition": "Нет информации о местоположении",
  "weared": "Надет",
  "nonWeared": "Нет",
  "age": "лет",
  "globalView": "Общий вид",
  "showNames": "Показать имя",
  "hideNames": "Скрыть имя",
  "showOrgFences": "Показать зоны",
  "hideOrgFences": "Скрыть зоны",
  "checkGroupTitle": "Пожалуйста выберете зоны группы, которые хотите показать",
  "checkAll": "Полная выборка",
  "pleaseSelectAScene": "Выберите сцену",
  stepNumber:"Номер шага",
  bodyTemperature:'Температура тела',
  systolicPressure:'СИСТОЛЬНЫЙ',
  diastolicPressure:'ДИАСТОЛЬНЫЙ',
  vitalSigns:'Здоровье',
  latitudeLongitude: 'Широта и долгота',
  temperature:'Температура',
}
      export default home
    